<template>
  <div id="vehicle_vision_system">
    <div class="font">
      <span class="introSubTitle"><b>车载视觉实时处理系统</b></span>
      <p class="textStyle">
        研制了车载视觉实时处理系统，突破了基于深度学习的车载视觉动、静态障碍物实时探测技术，支持双目深度信息提取和距离测量，以及视觉车道线、车辆、行人、交通标识、地面标识、交通灯的联合检测。
      </p>
    </div>
    <!-- <br/>   -->
    <img width="100%" src="@/assets/img/scientific/Car.jpg" />
  </div>
</template>

<script>
// import myVideo from "../../node_modules/vue-video";

export default {
  data() {
    return {
    };
  },
};
</script>

<style lang="less">
#vehicle_vision_system {
  margin-top: 20px;
  // .font {
  //   // font-family: "Times New Roman", Times, serif;
  // }
}
</style>
